// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__xvb5V","item":"PaymentsMobile_item__3eTmA","label":"PaymentsMobile_label__3XVDA","amount":"PaymentsMobile_amount__2ErZw"};